import React from "react";
import { ChevronLeft } from "lucide-react";

const TrackOrdersPage = ({ onBack }) => (
  <div>
    <button
      onClick={onBack}
      className="flex items-center gap-1 mb-3 text-sm text-gray-600"
    >
      <ChevronLeft size={18} /> Back
    </button>
    <h3 className="text-lg font-semibold mb-3 text-gray-800">Track Orders</h3>
    <p className="text-sm text-gray-500">
      You have no active orders right now.
    </p>
  </div>
);

export default TrackOrdersPage;
